import React from 'react';
import Language_i18 from '../js/useNationalLanguage.jsx';
import LoginHomeProcess from './login_home_process.jsx';
import firstDataHome1 from './login_home_1.json';

function HeaderHealing() {
    const { lang } = Language_i18();
    const domain = window.location.hostname; // Lấy tên miền hiện tại

    const first_data_home_1 = firstDataHome1;
    const first_data_home_2 = {
        vi: {
            textToSpeech: "Chuyển văn bản thành giọng nói",
            speechToText: "Chuyển giọng nói thành văn bản",
            imageToText: "Chuyển hình ảnh sang chữ viết",
        },
        en: {
            textToSpeech: "Text to Speech",
            speechToText: "Speech to Text",
            imageToText: "Image to Text",
        }
    };
    const homeText = first_data_home_1[lang] || first_data_home_1.en;

    return (
        <header className="mx-3 text-white py-1 mt-4">
            <div className="container border-2 rounded-xl mx-auto text-center">
                <h1 className="text-4xl font-semibold mt-3 text-center">
                    {domain} {homeText.healingTitle}
                </h1>

                <LoginHomeProcess
                    lang={lang}
                    first_data_home_1={first_data_home_1}
                    first_data_home_2={first_data_home_2}
                />
            </div>
        </header>
    );
}

export default HeaderHealing;
